import { IConfirmation, IExtraData } from 'app/pages/frames/util/interface';
import { AppContext as IAppContext } from 'common/interface';
import { createContext, useState } from 'react';

const AppContext = createContext<IAppContext>(null as any);

const AppContextProvider = ({ children, state = null }: any) => {
  const [confirmation, setConfirmation] = useState<IConfirmation>(
    state && state.confirmation ? state.confirmation : (null as any),
  );
  const [extraData, setExtraData] = useState<IExtraData>(state && state.extraData ? state.extraData : (null as any));

  return (
    <AppContext.Provider
      value={{
        confirmation,
        setConfirmation,
        extraData,
        setExtraData,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export { AppContext, AppContextProvider };
